export const AlertsToggleButtonsEnum = {
  INITIAL_LOAN: 'initialLoan',
  WITH_PENDING_CHANGES: 'withPendingChanges',
};

export const toggleButtons = [
  { value: AlertsToggleButtonsEnum.INITIAL_LOAN, label: 'Initial Loan' },
  { value: AlertsToggleButtonsEnum.WITH_PENDING_CHANGES, label: 'With Pending Changes' },
];

// Item rows, category rows and the table header must share this width or the Result column misaligns.
export const STATUS_COLUMN_FRACTION = 0.18;
export const STATUS_COLUMN_WIDTH = '18%';
